import React from 'react'
import styled from 'styled-components'

export default function InvalidHeader({ key, response }: { key: string; response: string[][] }) {
    return (
        <span style={{ display: 'flex', flexDirection: 'column' }} key={'collumns-info' + key}>
            <p style={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px' }}>
                The file you uploaded does not <strong>match</strong> the <strong>template header</strong> of this
                database. You will <strong>need to upload</strong> the file again. See below what is{' '}
                <strong>expected</strong> and what was <strong>uploaded</strong>:
            </p>
            <TableContainer>
                <thead className="tableHeader">
                    <tr className="headerRow">
                        <th className="headerText" style={{ width: '50%' }}>
                            Expected
                        </th>
                        <th className="headerText" style={{ width: '50%' }}>
                            Given
                        </th>
                    </tr>
                </thead>
                <tbody className="main">
                    {response.map(([giv, expt], index) => {
                        return (
                            <tr className="mainRow">
                                <td className="givenColumn" key={`given-row-${index}`}>
                                    <span>{giv}</span>
                                </td>

                                <td
                                    className={'expectedColumn' + (giv === expt ? '' : 'Error')}
                                    key={`expect-row-${index}`}
                                >
                                    <i className={'far fa-' + (giv === expt ? 'check-' : 'exclamation-') + 'circle'} />
                                    <span>{expt}</span>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </TableContainer>
        </span>
    )
}

const TableContainer = styled.table`
    width: 95%;
    height: 100%;
    display: table;
    align-items: center;
    color: var(--gray-800);
    border-radius: 4px;

    table,
    th,
    td {
        border: 1px solid var(--gray-300);
    }

    td i {
        padding-right: 4px;
    }

    .tableHeader {
        height: 32px;

        .headerRow {
            .headerText {
                padding: 8px;
                width: 50%;
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                background: var(--gray-100);
            }
        }
    }

    .main {
        td {
            height: 40px;
            padding: 8px;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
        .mainRow {
            /* font-weight: 400;
            font-size: 16px;
            line-height: 24px; */

            .givenColumn {
                width: 50%;
            }

            .expectedColumn {
                width: 50%;

                i {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 24px;
                    color: var(--green-700);
                }

                span {
                }
            }

            .expectedColumnError {
                width: 50%;

                i {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 24px;
                    color: var(--red-700);
                }

                span {
                }
            }
        }
    }
`
